import { useEffect, useState } from "react";
import { authService } from "../services/api";
import { useBotCurrency } from "./useBotCurrency";
import { isOnlyUpsellBlocked } from "../utils/gateways";
import { useAuth } from "../context/AuthProvider";

/** Lista de gateways do dono (para regras que dependem do cartão conectado). */
export function useGatewayList() {
    const [list, setList] = useState(null);
    useEffect(() => {
        let alive = true;
        authService.gateways.list_gateways()
            .then((res) => { if (alive) setList(res.data?.data || []); })
            .catch(() => { if (alive) setList([]); });
        return () => { alive = false; };
    }, []);
    return list;
}

/**
 * "Apenas Upsell" bloqueada neste bot? (bot Global ou cartão conectado no
 * escopo dele — mesma regra do backend, que recusa salvar). Enquanto carrega,
 * devolve false (o backend é quem garante).
 */
export function useOnlyUpsellBlocked(botId) {
    const { currencyMode } = useBotCurrency(botId);
    const gateways = useGatewayList();
    const isAdmin = useAuth()?.user?.is_admin === true;
    return isOnlyUpsellBlocked({ currencyMode, gateways: gateways || [], botIds: botId ? [botId] : [], isAdmin });
}
